








import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
    name: "AppContainer"
})
export default class AppContainer extends Vue {}
